<svelte:options runes={false} />

<script>
  export let label;
  export let value;
  export let grand = false;
</script>

<div class:grand><span>{label}</span><strong>{value}</strong></div>
